module.exports = __webpack_public_path__ + "static/media/leaderboard-one.789e64a5.png";